var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    [
      _c("v-card-title", [_vm._v(" Files Available For Download ")]),
      _c(
        "v-card-text",
        [
          _vm.filesRetreived
            ? _c(
                "div",
                _vm._l(_vm.files, function (file) {
                  return _c("div", { key: file.id }, [
                    _c("a", { attrs: { href: file.sasStoragePath } }, [
                      _vm._v(_vm._s(file.fileName)),
                    ]),
                  ])
                }),
                0
              )
            : _c("v-skeleton-loader", { attrs: { type: "text" } }),
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { color: "error", outlined: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close-file-dialog")
                },
              },
            },
            [_vm._v("Close")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }